import { render, staticRenderFns } from "./ShiftsView.vue?vue&type=template&id=e20ff1e4&scoped=true"
import script from "../js/Shift?vue&type=script&lang=js&external"
export * from "../js/Shift?vue&type=script&lang=js&external"
import style0 from "./ShiftsView.vue?vue&type=style&index=0&id=e20ff1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ff1e4",
  null
  
)

export default component.exports